<div class="modal-header">
  <h5 class="modal-title">Tải lên thông tin KH từ file excel</h5>
  <button type="button" class="close" (click)="dialogRef.hide()" id="cs-add-new-form-close-form-id">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="card-body p-0">
  <div class="wrap-content">
    <div class="files">
      <input type="file" #singleFile class="form-control" (change)="onSelectFile($event)" [required]="true" accept="application/vnd.ms-excel">
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="mr-5">
    <button class="btn btn-link" (click)="downloadTemplate()"><i class="pw-download"></i>Tải file mẫu</button>
  </div>
  <div class="start">
    <button type="button" class="btn btnClose close-button"
            (click)="dialogRef.hide()" id="cs-add-new-form-button-close-id">Hủy
    </button>
  </div>
  <div class="end">
    <button type="button" class="btn btn-primary btnSave save-new-button mr-2"
            (click)="importCooperative()">Tải lên
    </button>
  </div>
</div>
